import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../models/DataModel';
import './ZipDownloadNotificationBanner.scss';

/**
 * <ZipDownloadNotificationBanner> - child component of <GlobalBanner>
 */
export default class ZipDownloadNotificationBanner extends React.Component {

  constructor(props) {
    super(props);
    ZipDownloadNotificationBanner.propTypes = {
      /** Name of the closeoutable (project, build, or task) to be displayed in the banner */
      zipFileName: PropTypes.string.isRequired,
    };
    this.state = {
      shown: false,
    };

    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });

    this.closeBanner = this.closeBanner.bind(this);
    this.navigateToDestination = this.navigateToDestination.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 0);
  }

  /** HELPERS */
  closeBanner() {
    return new Promise((resolve) => {
      this.setState({ shown: false });
      // wait for animation to actually close banner
      setTimeout(() => {
        resolve();
        // clear from local storage and hide the component
        dataModel.hideGlobalBanner(this.props.bannerType, true);
      }, 150);
    });
  }

  async navigateToDestination() {
    const { zipFileId } = this.props;
    const fileUrl = process.env.REACT_APP_API + '/zip-closeouts?' +
                    'zip_closeout_id=' + zipFileId +
                    '&current_company=' + localStorage.current_company_id +
                    '&token=' + localStorage.token;

    // Function to validate URL before navigation
    const response = await fetch(fileUrl);  
    if (response.ok) {
      const link = document.createElement('a');
      link.href = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const errorMessage = 'zip closeout not found';
      dataModel.displayInfoErrorMessage(errorMessage, 4000);
    }

    this.closeBanner();
  }

  render() {
    let bannerText =
        <span className="zip-download-banner__text">
          Your Zip file ready for download&nbsp;
          <p onClick={this.navigateToDestination} className="zip-download-banner__link">Click here!</p>
        </span>;

    return (
      <span className={'zip-download-banner' + (this.state.shown ? '' : ' zip-download-banner--closing')}>
        { bannerText }
        <span className="zip-download-banner__close" onClick={this.closeBanner}>&times;</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/banners/ZipDownloadNotificationBanner/index.js